/**
 * awe-product-specs.js
 *
 * Listens for Horizon's `variant:update` event on the product page and:
 *   1. Updates the `#specs` element with the incoming variant's specs metafield HTML.
 *   2. Updates `[data-inventory-msg]` elements with low-stock urgency text.
 *
 * Loaded only via sections/product-information.liquid — never runs on other pages.
 */

document.addEventListener("variant:update", event => {
  const resource = /** @type {CustomEvent} */ (event).detail?.resource;
  if (!resource) return;

  // 1. Specs metafield
  const specsEl = document.getElementById("specs");
  if (specsEl && "specs" in resource) {
    specsEl.innerHTML = resource.specs ?? "";
  }

  // 2. Inventory urgency messages
  const msgs = document.querySelectorAll("[data-inventory-msg]");
  if (msgs.length === 0) return;

  const qty = resource.inventory_quantity;
  const show =
    resource.inventory_management === "shopify" &&
    resource.inventory_policy === "deny" &&
    qty > 0 &&
    qty < 10;

  msgs.forEach(el => {
    el.textContent = show ? `Hurry! Only ${qty} Left` : "";
    el.style.display = show ? "" : "none";
  });
});
